import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { Button, Container, Row, Col, Card } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import NewConfirmationModal from '../shared/NewconfirmationModal';
import ConfirmationModal from '../shared/ConfirmationModal';
import AllFailureModal from '../shared/AllFailureModal';

type NoticeFormValues = {
  job_id: string;
  title: string;
  description: string;
  audience: string;
  posted_by: string;
  expiry_date: string;
};

const NoticeAdd: React.FC = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [failureModalShow, setFailureModalShow] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [failureMessage, setFailureMessage] = useState("");
  const [modalMessage, setModalMessage] = useState('');
  const [navigateAfterConfirm, setNavigateAfterConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState<NoticeFormValues | null>(null);
  const [formikHelpers, setFormikHelpers] = useState<FormikHelpers<NoticeFormValues> | null>(null);
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const initialValues: NoticeFormValues = {
    job_id: '',
    title: '',
    description: '',
    audience: '',
    posted_by: '',
    expiry_date: ''
  };

  const validationSchema = Yup.object({
    job_id: Yup.string().required('Job ID is required'),
    title: Yup.string().required('Title is required'),
    description: Yup.string().required('Description is required'),
    audience: Yup.string().required('Audience is required'),
    posted_by: Yup.string().required('Posted by is required'),
    expiry_date: Yup.date().required('Expiry Date is required').nullable(),
  });

  const onSubmit = async (values: NoticeFormValues, { setSubmitting, resetForm }: FormikHelpers<NoticeFormValues>) => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_API_URL + 'notice/createnotice';
      const response = await axios.post(url, values);
      if(response.status===201) {
        setSuccessMessage('Notice added successfully!');
        setShowSuccessModal(true);
        setTimeout(() => {
          navigate('/noticelist');
        }
        , 3000);
      }
    } catch (error) {
      console.error(error);
      setFailureMessage('Something Went wrong, please try again!');
      setFailureModalShow(true);
    }
    setLoading(false);
    setSubmitting(false);
  };
  const handleSubmitConfirmation = (values: NoticeFormValues, helpers: FormikHelpers<NoticeFormValues>) => {
    setFormValues(values);
    setFormikHelpers(helpers);
    setModalMessage('Are you sure you want to add this notice?');
    setModalShow(true);
  };

  const handleConfirmSubmit = async () => {
    setModalShow(false);
    if (formValues && formikHelpers) {
      await onSubmit(formValues, formikHelpers);
    }
  };

  // const handleSuccessModalClose = () => {
  //   setShowSuccessModal(false);
  //   navigate('/noticelist'); // Immediate navigation if modal closed manually
  // };
  return (
    <>
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={8}>
            <Card className="shadow" style={{ maxHeight: '80vh', overflow: 'auto' }}>
              <Card.Header className="bg-info text-white text-center">
                <h4>Create Notice</h4>
              </Card.Header>
              <Card.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>

     
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values,helpers) => {
          handleSubmitConfirmation(values,helpers);
        }}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                
                  <label htmlFor="job_id" className="form-label">Job ID:</label>
                  <Field
                    type="text"
                    id="job_id"
                    name="job_id"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="job_id"
                    component="div"
                    className="text-danger"
                  />
                
              </Col>
              <Col md={6}>
               
                  <label htmlFor="title" className="form-label">Title:</label>
                  <Field
                    type="text"
                    id="title"
                    name="title"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="title"
                    component="div"
                    className="text-danger"
                  />
             
              </Col>
            </Row>

            <Row  className="mb-3">
              <Col md={12}>
                
                  <label htmlFor="description" className="form-label">Description:</label>
                  <Field
                    as="textarea"
                    id="description"
                    name="description"
                    className="form-control"
                    rows={4}
                  />
                  <ErrorMessage
                    name="description"
                    component="div"
                    className="text-danger"
                  />
              
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                
                  <label htmlFor="audience" className="form-label">Audience:</label>
                  <Field
                    type="text"
                    id="audience"
                    name="audience"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="audience"
                    component="div"
                    className="text-danger"
                  />
                
              </Col>
              <Col md={6}>
                
                  <label htmlFor="posted_by" className="form-label">Posted By:</label>
                  <Field
                    type="text"
                    id="posted_by"
                    name="posted_by"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="posted_by"
                    component="div"
                    className="text-danger"
                  />
               
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                
                  <label htmlFor="expiry_date" className="form-label">Expiry Date:</label>
                  <Field
                    type="date"
                    id="expiry_date"
                    name="expiry_date"
                    className="form-control"
                    min={getTodayDate()}
                  />
                  <ErrorMessage
                    name="expiry_date"
                    component="div"
                    className="text-danger"
                  />

              </Col>
            </Row>
          
            <Row className="mt-4">
              <Col className="text-center">
            <Button type="submit" variant="success" disabled={isSubmitting || !isValid || !dirty}>
              Add Notice
            </Button>
            <Button variant="danger" className="mx-2" onClick={() => navigate("/noticelist")}>
             Go Back
            </Button>


           
          </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ConfirmationModal 
        show={modalShow}
        onHide={() => setModalShow(false)}
        modalMessage={modalMessage}
        operationType="Confirm"
        confirmation={handleConfirmSubmit}
      />
  <NewConfirmationModal
        show={showSuccessModal}
        modalMessage={successMessage}
        onHide={() => setShowSuccessModal(false)}
        operationType="OK"
        timeoutDuration={3000}
      />
      <AllFailureModal
        show={failureModalShow}
        modalMessage="Something went wrong, please try again!"
        onHide={() => setFailureModalShow(false)}
      />
    </>
  );
};

export default NoticeAdd;